import { toDateOnlyApiParam } from "./dateUtils";
import { isEpicWorkItemTypeLabel } from "../Pages/Issues/issueMappers";

function isBugWorkItemTypeLabel(label) {
  return (
    String(label ?? "")
      .trim()
      .toLowerCase() === "bug"
  );
}

/**
 * Shared POST create / PATCH update body — same field names as API contract.
 * Pass `version` for updates (optimistic lock from GET detail).
 */
export function buildWorkItemSubmitBody({
  version,
  typeId,
  typeLabel = "",
  title,
  priorityId,
  description,
  statusId,
  assigneeId,
  parentId,
  originalEstimate,
  remainingEstimateMinutes,
  storyPoints,
  startDate,
  dueDate,
  isBacklog,
  bugDetails,
  reporterId,
  progressPercent,
  projectId,
}) {
  const isEpic = isEpicWorkItemTypeLabel(typeLabel);
  const isBug = isBugWorkItemTypeLabel(typeLabel);

  const body = {
    ...(version != null ? { version } : {}),
    typeId: typeId != null && String(typeId).trim() !== "" ? String(typeId).trim() : null,
    title: String(title ?? "").trim(),
    priorityId:
      priorityId != null && String(priorityId).trim() !== "" ? String(priorityId).trim() : null,
    description: description != null && String(description).trim() !== "" ? description : null,
  };

  if (statusId != null && String(statusId).trim() !== "") {
    body.statusId = String(statusId).trim();
  }

  if (assigneeId != null && String(assigneeId).trim() !== "") {
    body.assigneeId = String(assigneeId).trim();
  } else if (assigneeId === null) {
    body.assigneeId = null;
  }

  if (!isEpic) {
    const pid = parentId != null ? String(parentId).trim() : "";
    body.parentId = pid || null;
  }

  const estimateTrimmed = originalEstimate != null ? String(originalEstimate).trim() : "";
  body.originalEstimate = estimateTrimmed || null;

  if (remainingEstimateMinutes != null) {
    body.remainingEstimateMinutes = remainingEstimateMinutes;
  }

  if (storyPoints != null && !Number.isNaN(Number(storyPoints))) {
    body.storyPoints = Number(storyPoints);
  }

  body.startDate = toDateOnlyApiParam(startDate) || null;
  body.dueDate = toDateOnlyApiParam(dueDate) || null;

  if (isBacklog === true) {
    body.isBacklog = true;
  }

  if (isBug && bugDetails && typeof bugDetails === "object") {
    body.bugDetails = bugDetails;
  }

  if (reporterId !== undefined) {
    body.reporterId =
      reporterId != null && String(reporterId).trim() !== "" ? String(reporterId).trim() : null;
  }

  if (progressPercent != null) {
    body.progressPercent = progressPercent;
  }

  if (projectId != null && String(projectId).trim() !== "") {
    body.projectId = String(projectId).trim();
  }

  return body;
}

/** Build bugDetails from create/backlog form fields. */
export function buildBugDetailsFromFormFields(data) {
  const envJoined = Array.isArray(data.environment)
    ? data.environment.length
      ? data.environment.join(",")
      : null
    : data.environment?.trim() || null;
  return {
    severityId: data.severityId?.trim() || null,
    environment: envJoined,
    reproductionSteps: data.reproductionSteps?.trim() || null,
  };
}

/** Build bugDetails from IssueDetail local issue state. */
export function buildBugDetailsFromIssueState(issue) {
  const envRaw = issue.environment != null ? String(issue.environment).trim() : "";
  return {
    severityId: issue.severityId || null,
    environment: envRaw || null,
    reproductionSteps: issue.reproduction?.trim() || null,
  };
}
